import React from 'react';
import { Link } from 'react-router-dom';
import { CHAPTERS } from '../mock';
import { MapPin, ArrowRight, Facebook, Instagram } from 'lucide-react';

function SocialPills({ socials }) {
  const items = [
    socials?.facebook && { Icon: Facebook, label: 'Facebook' },
    socials?.instagram && { Icon: Instagram, label: 'Instagram' },
  ].filter(Boolean);
  if (items.length === 0) return <span className="text-[10px] text-cbtu-muted tracking-widest">SOCIALS COMING SOON</span>;
  return (
    <div className="flex items-center gap-1.5">
      {items.map(({ Icon, label }) => (
        <span key={label} className="p-1 border border-gold/40 text-gold rounded-sm" aria-label={label}>
          <Icon size={11} />
        </span>
      ))}
    </div>
  );
}

export default function ChaptersIndex() {
  return (
    <div className="fade-in-up">
      <section className="banner-bg section-noise">
        <div className="max-w-6xl mx-auto px-4 py-14 text-center">
          <div className="chip mb-3">SEVEN CHAPTERS · FOUR STATES</div>
          <h1 className="font-display text-5xl md:text-6xl gold-text-fill">CHAPTERS</h1>
          <p className="text-cbtu-text/90 max-w-2xl mx-auto mt-3">Find your local CBTU chapter. Each chapter organizes around the unique needs of its community while building regional and national labor power.</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-6">
        {CHAPTERS.map((c) => (
          <Link key={c.slug} to={`/chapters/${c.slug}`} className="card-dark p-6 rounded-md block">
            <div className="flex items-start justify-between mb-2">
              <h2 className="font-display text-3xl text-cbtu-cream">{c.name}</h2>
              <span className="chip">{c.state}</span>
            </div>
            <div className="flex items-center gap-4 text-xs text-cbtu-muted mb-3">
              <span className="inline-flex items-center gap-1"><MapPin size={12} className="text-gold" />{c.city}</span>
              <span>Est. {c.founded}</span>
            </div>
            <p className="text-cbtu-text/85 mb-4">{c.summary}</p>
            <div className="flex items-center justify-between">
              <div className="text-xs text-gold tracking-widest font-heading">{c.president}{c.union ? ` • ${c.union}` : ''}</div>
              <span className="text-gold-bright text-sm inline-flex items-center gap-1">View chapter <ArrowRight size={14} /></span>
            </div>
            <div className="mt-3 pt-3 border-t border-gold/15 flex items-center justify-between">
              <SocialPills socials={c.socials} />
              <span className="text-[10px] tracking-widest text-cbtu-muted">CHAPTER #{String(CHAPTERS.indexOf(c) + 1).padStart(2, '0')}</span>
            </div>
          </Link>
        ))}
      </section>
    </div>
  );
}
